import React from 'react';
import styles from '../styles.module.css';

export default function AboutStatCard({ item }: { item?: { label?: string; value?: string } }) {
  return (
    <div className={`card ${styles.card}`}>
      <div className={styles.value}>{item?.value}</div>
      <div className={styles.label}>{item?.label}</div>
    </div>
  );
}
